import { createSelector } from 'reselect';
import { RootState } from '../store';
import { NotificationState } from '../slices/notification';

export const notificationSelector: (state: RootState) => NotificationState = (
  state: RootState,
) => state.notification;
